import apiService from 'src/enviroment'

const getAllUsers = async () => {
  try {
    const response = await apiService.get('/admin/usuarios_inventarios/')
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const getBlockedUsers = async () => {
  try {
    const response = await apiService.get('runt/admin/usuarios/bloqueados/')
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const getUser = async (id) => {
  try {
    const response = await apiService.get(
      `/admin/usuarios_inventarios/?usuario_id=${id}`,
    )
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const createUser = async (params) => {
  try {
    const response = await apiService.post(
      '/admin/usuarios_inventarios/',
      params,
    )
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const updateUser = async (params) => {
  try {
    const response = await apiService.put(
      '/admin/usuarios_inventarios/',
      params,
    )
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const updatePassword = async (params) => {
  try {
    const response = await apiService.put(
      '/admin/usuarios_inventarios/',
      params,
    )
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const deleteUser = async (id) => {
  try {
    const response = await apiService.delete(
      `/admin/usuarios_inventarios/?id=${id}`,
    )
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const unlockuser = async (correo) => {
  try {
    const response = await apiService.delete(
      `/admin/usuarios/bloqueados/?correo=${correo}`,
    )
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const getAllDestinataries = async () => {
  try {
    const response = await apiService.get('/maestros/destinatarios/')
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const getUserDestinatarie = async (id) => {
  try {
    const response = await apiService.get(
      `/admin/usuario_destinatario/?usuario_id=${id}`,
    )
    if (response.status === 200) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

const addDestinataire = async (params) => {
  try {
    const response = await apiService.post(
      '/admin/usuario_destinatario/',
      params,
    )
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const deleteDestinataire = async (id) => {
  try {
    const response = await apiService.delete(
      `/admin/usuario_destinatario/?id=${id}`,
    )
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const adminInventoryService = {
  getAllDestinataries,
  getUserDestinatarie,
  deleteDestinataire,
  addDestinataire,
  updatePassword,
  getAllUsers,
  getBlockedUsers,
  unlockuser,
  deleteUser,
  createUser,
  updateUser,
  getUser,
}

export default adminInventoryService
